export default {"src":"/_next/static/media/ic-clipboard.c3e9dbbd.svg","height":46,"width":47};